
import React from 'react';
import { Button } from '@/components/ui/button';
import { User, Edit3 } from 'lucide-react';
import { UserRole, AgeGroup } from '@/types/user';
import { useNavigate } from 'react-router-dom';
import { useUserMenuData } from '@/components/UserMenu/useUserMenuData';

interface WelcomeHeaderProps {
  username: string;
  userRole: UserRole;
  userAgeGroup: AgeGroup;
  isInternalUser: boolean;
  isProfileComplete: boolean;
  onProfileNavigation: () => void;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({
  username,
  userRole,
  userAgeGroup,
  isInternalUser,
  isProfileComplete,
  onProfileNavigation
}) => {
  const navigate = useNavigate();
  const { profileRoute } = useUserMenuData();

  const handleViewProfile = () => {
    console.log('=== WELCOME HEADER VIEW PROFILE ===');
    console.log('Profile Route:', profileRoute);
    console.log('Is Internal User:', isInternalUser);
    
    // Use the same profile route logic as the UserMenu
    navigate(profileRoute);
  };

  return (
    <div className="bg-gradient-to-r from-sports-green/20 to-sports-green/10 rounded-lg p-6 border border-sports-green/30 mt-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">
            Welcome back, {username}!
          </h1>
          <div className="flex flex-wrap gap-2">
            <span className="px-3 py-1 bg-sports-green/20 text-sports-green rounded-full text-sm font-medium border border-sports-green/30">
              {userRole.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
            </span>
            <span className="px-3 py-1 bg-gray-700 text-gray-300 rounded-full text-sm">
              {userAgeGroup === '13-and-under' ? '13 and Under' : 
               userAgeGroup === '14-17' ? '14-17 years' : '18+ years'}
            </span>
            {userAgeGroup !== '18-plus' && (
              <span className="px-3 py-1 bg-yellow-600/20 text-yellow-400 rounded-full text-sm border border-yellow-600/30">
                Age-restricted features
              </span>
            )}
            {isInternalUser && (
              <span className="px-3 py-1 bg-blue-600/20 text-blue-400 rounded-full text-sm border border-blue-600/30">
                New School Account
              </span>
            )}
          </div>
        </div>
        
        <div className="flex gap-3">
          <Button
            onClick={handleViewProfile}
            className="flex items-center gap-2 bg-sports-green hover:bg-sports-green/90 text-black font-bold"
          >
            <User className="h-4 w-4" />
            View Profile
          </Button>
          {!isInternalUser && (
            <Button
              onClick={onProfileNavigation}
              variant={isProfileComplete ? "outline" : "default"}
              className={`flex items-center gap-2 ${
                !isProfileComplete 
                  ? 'bg-sports-green hover:bg-sports-green/90 text-black font-bold' 
                  : 'border-sports-green text-sports-green hover:bg-sports-green/10'
              }`}
            >
              <Edit3 className="h-4 w-4" />
              {isProfileComplete ? 'Edit Profile' : 'Complete Profile'}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;
